// The app is used in Vietnamese only: dot as the thousands separator (2.500).
export const LOCALE = 'vi-VN';

export const kcal = (n) => (n == null ? '–' : Math.round(n).toLocaleString(LOCALE));
export const grams = (n) => (n == null ? '–' : `${Math.round(n).toLocaleString(LOCALE)} g`);
export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner', 'snack'];

export const MEAL_LABELS = { breakfast: 'Bữa sáng', lunch: 'Bữa trưa', dinner: 'Bữa tối', snack: 'Ăn vặt' };
// Segmented picker in the meal sheet.
export const MEAL_SHORT = { breakfast: 'Sáng', lunch: 'Trưa', dinner: 'Tối', snack: 'Ăn vặt' };

// Per-slot icon and its tile colours (lightness differs as well as hue, so colour is never the only signal).
export const MEAL_STYLE = {
  breakfast: { icon: 'sunrise', tile: 'bg-[#fdeee3] text-[#a4471b]' },
  lunch: { icon: 'sun', tile: 'bg-[#fdf3d4] text-[#8a6100]' },
  dinner: { icon: 'moon', tile: 'bg-[#e8ebfa] text-[#3b4bb0]' },
  snack: { icon: 'apple', tile: 'bg-[#fbe6ec] text-[#a3324f]' },
};

// The slot a new meal goes into by default, from the time of day (eating after midnight is a snack).
export const mealTypeForNow = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 5) return 'snack';
  if (hour < 11) return 'breakfast';
  if (hour < 15) return 'lunch';
  if (hour < 21) return 'dinner';
  return 'snack';
};

export const clockTime = (iso) => new Date(iso).toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' });

// For matching what's typed regardless of accents and case: "tap chan" finds "Tập chân".
export const foldText = (text) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[đĐ]/g, 'd').toLowerCase().replace(/\s+/g, ' ').trim();
